import axios from "axios";
import { API_BASE } from "./common_api";

const api = axios.create({
  baseURL: API_BASE,
});

/* ===============================
    DASHBOARD RELATED APIS
=============================== */

// 🔹 Get Employee Profile + Role
export const fetchEmployeeProfile = (email) => {
  return api.get(`/dashboard/employee?email=${email}`);
};

// 🔹 Get Team Members List
export const fetchTeamMembers = (email) => {
  return api.get(`/dashboard/view_team?email=${email}`);
};

// 🔹 Get Reflection Questions
export const fetchReflectionQuestions = (period) => {
  return api.get(`/reflection/questions?period=${period}`);
};

// 🔹 Get Reminder
export const fetchReminderAPI = (email, period, selectedDate) => {
  return api.get(
    `/reflection/reminder?email=${encodeURIComponent(
      email
    )}&period=${period}&selected_date=${selectedDate}`
  );
};

// 🔹 AI Polish
export const polishAnswerAPI = (text) => {
  return api.post(`/ai/rephrase`, { text });
};

// 🔹 Save Reflection
export const saveReflectionAPI = (formData) => {
  return api.post(`/reflection/submit`, formData);
};

// 🔹 AI Chat Ask
export const askAIChatAPI = (formData) => {
  return api.post(`/reflection/ask`, formData);
};
